import { useState } from "react";
import { SiteFooter, SiteHeader } from "../components/site-header";
import {
  readAnalyticsOptOut,
  setAnalyticsOptOut,
} from "../analytics/analytics-provider";
import { useRuntimeConfig } from "../runtime-config";

export function PrivacyRoute() {
  const { pilotMode } = useRuntimeConfig();
  const [analyticsOptedOut, setAnalyticsOptedOut] =
    useState(readAnalyticsOptOut);

  const toggleAnalyticsOptOut = () => {
    const nextOptOut = !analyticsOptedOut;
    setAnalyticsOptOut(nextOptOut);
    setAnalyticsOptedOut(nextOptOut);
  };

  return (
    <div className="site-shell">
      <SiteHeader />
      <main className="document-page">
        <header className="document-page__header">
          <p className="eyebrow">PRIVACY / DATA POLICY</p>
          <h1>プライバシーポリシー</h1>
          <p>性格劣化診断で扱うデータと、その保存方針を説明します。</p>
        </header>

        {pilotMode ? (
          <section aria-labelledby="pilot-mode-heading">
            <h2 id="pilot-mode-heading">パイロットモード</h2>
            <p>
              設問・結果・操作体験の品質改善を目的として、事前の説明に明示同意した参加者の情報だけを期間限定で保存します。
            </p>
            <h3>保存する項目</h3>
            <ul>
              <li>24問の回答</li>
              <li>選択したきっかけ候補</li>
              <li>採点結果と結果タイプ</li>
              <li>診断所要時間</li>
              <li>レビューの評価項目と自由記述</li>
            </ul>
            <h3>保存期間</h3>
            <p>
              パイロットデータは一般公開から最長30日後まで保存し、期間内に回答とレビューを削除します。個別回答を含まない集計結果と改善記録だけを残します。
            </p>
            <div className="notice-box">
              <h3>個人情報を入力しないでください</h3>
              <p>
                氏名、メールアドレス、SNS
                ID、連絡先、第三者を特定できる情報を自由記述へ入力しないでください。生年月日は取得しません。
              </p>
            </div>
          </section>
        ) : (
          <section aria-labelledby="public-mode-heading">
            <h2 id="public-mode-heading">一般公開モード</h2>
            <p>
              回答、年齢、仕事、環境要因、IPアドレスを永続保存しません。診断中の回答は同一タブのsessionStorageへ一時保存し、リロード時に復帰します。結果確定時に生の回答を削除し、採点済みのresultSnapshot（8パターン、4領域、変化指数、結果タイプ、コメント番号、選択したきっかけ候補）へ置き換えます。resultSnapshotは同一タブを閉じるまで保持し、生の回答配列は残しません。
            </p>
            <p>
              公開共有を選んだ場合に限り、スコア、結果タイプ、コメント番号、コンテンツバージョン、作成日時など、公開表示に必要な最小結果を保存します。生の回答やきっかけ候補は含みません。
            </p>
          </section>
        )}

        <section aria-labelledby="ads-heading">
          <h2 id="ads-heading">広告について</h2>
          <p>
            結果ページと公開共有ページに、運営者が選定したPR表記付きのリンクを掲載することがあります。掲載枠は診断の回答内容を外部へ送信しません。
          </p>
          <p>
            掲載枠には広告配信事業者「A8.net」（株式会社ファンコミュニケーションズ）の効果測定用の画像が含まれ、広告の表示回数の計測に利用されます。PRリンクを選んだ場合は、遷移先の広告配信事業者が成果計測のためにCookie等を利用します。
          </p>
        </section>

        <section aria-labelledby="analytics-heading">
          <h2 id="analytics-heading">アクセス解析</h2>
          <p>
            PostHog Cloud
            EUを使い、Cookieを使わない匿名アクセス解析を行います。IPアドレスを保存しない設定で、ページ表示、結果タイプ、スコア帯、流入、広告接触だけを集計します。
          </p>
          <p>
            回答、共有ID、個人情報を送らないほか、詳細スコアやきっかけ候補も送信しません。日ごとに変わる匿名ハッシュを使うため、長期にわたって同じ利用者を追跡しません。
          </p>
          <p>
            このブラウザではいつでも匿名アクセス解析を停止できます。停止の選択はこのサイトのfirst-party
            storageへ保存します。
          </p>
          <button type="button" onClick={toggleAnalyticsOptOut}>
            {analyticsOptedOut
              ? "匿名アクセス解析を再開"
              : "匿名アクセス解析を停止"}
          </button>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
